<template>
  <div class="login">
    <h2 style="color: white;">用 户 登 录</h2>
      <div class="adminImg">
      </div>
      <!-- <h3 style="color: white;">user</h3> -->
    <div class="loginForm">
      <van-form ref="ruleForm" :model="ruleForm" style="border: gainsboro 1px solid;" label-width="120px" >
        <van-cell-group>
          <van-popover
              v-model="showPopover"
              trigger="click"
              theme="dark"
              :actions="usernames"
              @select="onSelect"
              >
              <template #reference>
                  <van-field
                  v-model="ruleForm.userName"
                  label="用户名："
                  placeholder="请输入用户名"
                  :rules="[{ required: true,message:'请输入用户名'}]"
                  @input="showPopover = false"
                  />
              </template>
          </van-popover>
          <van-field
            v-model="ruleForm.password"
            label="密码："
            placeholder="密码"
            :type="passwordType"
            :rules="[{ required: true,message:'请输入密码'}]"
            >
            <template slot="right-icon">
              <span class="slots" @click="switchPasswordType" >
                <van-icon name="eye-o" v-if="passwordType === 'text'" />
                <van-icon name="closed-eye" v-else/>
              </span>
            </template>
          </van-field>
          <van-field
            v-model="ruleForm.validCode"
            label="图片验证码："
            placeholder="验证码"
            :rules="[{ required: true,}]"
            type="digit"
            maxlength="4"
            >
            <template #button>
              <!-- 图形验证码 -->
                <div  @click.stop="refreshCode">
                  <sidentify :identify-code="identifyCode" />
                </div>
            </template>
          </van-field>

          <van-field>
            <template #input>
              <!-- 用户类型 -->
              <van-radio-group v-model="userType" direction="horizontal">
                <van-radio name="1" checked-color="#3399ff">服务站用户</van-radio>
                <van-radio name="2" checked-color="#3399ff">管理员用户</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <!-- 记住密码 -->
          <!-- <van-checkbox v-model="rememberPassword" icon-size="24px" checked-color="#3399ff">记住密码</van-checkbox> -->
          <van-field>
            <template #input>
              <van-checkbox v-model="rememberPassword"  checked-color="#3399ff">记住密码</van-checkbox>
            </template>
            
          </van-field>
        </van-cell-group>
        <div>
          <div style="margin: 16px;">
            <van-button @click="onSubmit" round block type="info">登录</van-button>
            <van-button  @click="goHome" round style="width: 98%; margin-top: 2%;margin-left: 0;">返回首页</van-button>
          </div>
        </div>
      </van-form>
    </div>

    <!-- 修改密码 -->
    <van-overlay :show="showModify" @click="showModify=false">
      <div class="wrapper" @click.stop>
        <div class="statePoolBlock">
          <div class="title">
            <span>修改密码
            </span>
          </div>
          <van-form ref="modify"  :model="modifyForm">
            <van-cell-group>
              
              <van-field
                v-model="modifyForm.modifyPassword"
                label="密码："
                placeholder="密码"
                :type="modifyPasswordType"
                :rules="[{ required: true,message:'请输入密码'}]"
                >
                <template slot="right-icon">
                  <span class="slots" @click="changePasswordType" >
                    <van-icon name="eye-o" v-if="modifyPasswordType === 'text'" />
                    <van-icon name="closed-eye" v-else/>
                  </span>
                </template>
              </van-field>
              <van-field
                v-model="modifyForm.enterPassword"
                label="确认密码："
                placeholder="密码"
                :type="modifyPasswordType"
                :rules="[{ required: true,message:'请输入密码'}]"
                >
                <template slot="right-icon">
                  <span class="slots" @click="changePasswordType" >
                    <van-icon name="eye-o" v-if="modifyPasswordType === 'text'" />
                    <van-icon name="closed-eye" v-else/>
                  </span>
                </template>
              </van-field>
              <div style="margin: 16px;">
                <van-button round block type="info" @click="submitOverlay">
                  确定</van-button>
              </div>
            </van-cell-group>
          </van-form>
        </div>
      </div>
    </van-overlay>

  <!-- 图形验证码 -->
  <!-- <van-number-keyboard
    title="图形验证码"
    extra-key="."
    close-button-text="完成"
    v-model="ruleForm.validCode"
    :show="identifyKeyboardShow"
    @blur="blurIdentifyNo"
  />
    -->
  </div>
</template>

<script>
import{Login,StationUserLogin,ModifyStationUser} from '@/my_js/HttpRequest.js'
import { Notify,Dialog,Toast} from 'vant';
import Sidentify from '@/components/identify.vue'
import md5 from 'js-md5'
import store from '@/store/index.js'
import { WarningMsgBox } from '@/my_js/common.js';
// 验证手机号
export const validatphone = async(value)=>{
    const reg = new RegExp(/^1[3-9]\d{9}$/)
    if(value){
        if(!reg.test(value)){
          debugger
          console.log('value',value);
            Notify({ type: 'warning', message: '请输入正确的手机号' });
            return Promise.reject('请输入正确的手机号').catch(()=>{})
        }else{
            return Promise.resolve()
        }
    }else{
        return Promise.resolve()
    }
}
export default {
  components:{Sidentify},
  computed:{
        isValidPhone() {
            // 使用正则表达式来验证手机号
            const regex = /^1[3-9]\d{9}$/;
            return regex.test(this.ruleForm.phoneNo);
        },
    },
  created(){
      // 获取已保存的用户名和密码
      const savedUsers = JSON.parse(localStorage.getItem('users')) || []
      console.log('savedUsers',savedUsers);
      
     if(savedUsers.length == 0 ){
          this.showPopover = false
         
     }else{
      savedUsers.forEach(item => {
              this.usernames.push({text:item.username})
          })
     }
      console.log('usernames',this.usernames);
      
  },
  data(){
    return{
      showPopover: false,//显示登录用户列表
      usernames: [],//用户名列表
      rememberPassword:false,//记住密码
      passwordType:'password',//密码框输入类型
      modifyPasswordType:'password',//修改密码表单密码框输入类型
      identifyCode:'',//图片验证码
      identifyCodes:'0123456789',//随机验证码范围
      ruleForm: {
        userName:'',//用户名
        password:'',//密码
        phoneNo:'',//手机号
      },
      userType:'1',//用户类型  1:服务站用户  2:管理员用户
      showModify:false,//显示修改密码
      // modifyPassword:'',//修改的密码
      modifyForm:{
        modifyPassword:'',//修改的密码
        enterPassword:'',//确认密码
      },
      userInfo:null,//用户信息
      md5Password:null,//用户登录的密码
      // 手机号验证
      // phoneNoRules:[{ required:true,message:'请输入用户名', trigger:'change'},],
      // 验证码验证
      // verifyNoRules:[{required:true,message:'请输入密码',trigger:'change'},],
      // code:'',//存储验证码
    }
  },
  mounted(){
    // 组件挂载完毕刷新验证码
    this.refreshCode()
  },
  methods:{
      // 登录
      // onSubmit(){
      //     // this.showModify = true
      //     // return
      //     let _this = this;
      //     console.log('表单数据：', _this.ruleForm);
      //     // debugger
      //     _this.$refs.ruleForm.validate()
      //     .then(valid => {
      //         // 表单验证成功
      //         // debugger
      //         console.log('验证通过');
      //         // if(_this.ruleForm.verifyNo != _this.code){
      //         //   Notify({type:'warning',message:'短信验证码不一致'})
      //         //   return
      //         // }
      //         if(this.ruleForm.validCode != this.identifyCode){
      //         Notify({type:'warning',message:'图形验证码不一致'})
      //         return
      //         }
      //         const psd = md5(this.trimmedStr(this.ruleForm.password)).toUpperCase()
      //         console.log('加密后的密码',psd);
      //         this.md5Password = psd
      //         const dataArray = {
      //         userName:this.trimmedStr(this.ruleForm.userName),//用户名
      //         password:psd,//密码
      //         phoneNo: ''
      //         }
      //         console.log('dataArray',dataArray);
      //         // if(this.rememberPassword){
      //         //       // debugger
      //         //       const userExists = this.usernames.includes(this.ruleForm.userName);
      //         //       if (!userExists) {
      //         //       // 保存新用户
      //         //       const newUser = {
      //         //           username: this.ruleForm.userName,
      //         //           password: this.ruleForm.password,
      //         //       };
      //         //       const savedUsers = JSON.parse(localStorage.getItem('users')) || [];
      //         //       savedUsers.push(newUser);
      //         //       localStorage.setItem('users', JSON.stringify(savedUsers));
      //         //       }
      //         //   }else{
      //         //       // 移除用户
      //         //       const savedUsers = JSON.parse(localStorage.getItem('users')) || []
      //         //       const undatedUsers = savedUsers.filter(user => user.username !== this.ruleForm.userName)
      //         //       localStorage.setItem('users',JSON.stringify(undatedUsers))
      //         //   }
      //         if(this.userType == '1'){
      //             // if(this.rememberPassword){
      //             //     // debugger
      //             //     const userExists = this.usernames.includes(this.ruleForm.userName);
      //             //     if (!userExists) {
      //             //     // 保存新用户
      //             //     const newUser = {
      //             //         username: this.ruleForm.userName,
      //             //         password: this.ruleForm.password,
      //             //     };
      //             //     const savedUsers = JSON.parse(localStorage.getItem('users')) || [];
      //             //     savedUsers.push(newUser);
      //             //     localStorage.setItem('users', JSON.stringify(savedUsers));
      //             //     }
      //             // }else{
      //             //     // 移除用户
      //             //     const savedUsers = JSON.parse(localStorage.getItem('users')) || []
      //             //     const undatedUsers = savedUsers.filter(user => user.username !== this.ruleForm.userName)
      //             //     localStorage.setItem('users',JSON.stringify(undatedUsers))
      //             // }
      //             StationUserLogin(dataArray).then(res =>{
      //             console.log(res);
      //             this.userInfo = res.data
      //             if(this.rememberPassword){
      //                 const userExists = this.usernames.includes(this.ruleForm.userName);
      //                 if (!userExists) {
      //                 // 保存新用户
      //                 const newUser = {
      //                     username: this.ruleForm.userName,
      //                     password: this.ruleForm.password,
      //                 };
      //                 const savedUsers = JSON.parse(localStorage.getItem('users')) || [];
      //                 savedUsers.push(newUser);
      //                 localStorage.setItem('users', JSON.stringify(savedUsers));
      //                 this.usernames.push(this.ruleForm.userName);
      //                 }
      //             }
      //             if(res.code == 0){
      //             const userToken = res.msg
      //             // 将用户token保存到vuex中
      //             store.commit('changeLogin',{Authorization:userToken})
  
      //             const password = this.userInfo.idNo.substring(12,18)
      //             const psd = md5(this.trimmedStr(password)).toUpperCase()
  
      //             if(this.md5Password == psd){
      //                 console.log('密码是默认密码');
      //                 Dialog.alert({
      //                 title: '提示',
      //                 message: '<span style="color:#ff9933">该账号密码为初始化密码，为了保障账号的安全，请修改密码</span>',
      //                 confirmButtonColor: '#1989fa',
      //                 messageAlign:'left',
      //                 theme: 'round-button',
      //                 }).then(() => {
      //                 // on close
      //                 console.log('点击了确定');
      //                 // 修改密码提示框
      //                 this.showModify = true
                      
      //                 });
      //             }else if(this.md5Password != psd){
      //                 console.log('密码不是默认密码');
      //                 // 登录成功，进入服务站管理首页
      //                 _this.$router.push({ path: '/stationIndex' })
      //                 // 把用户登录信息保存到 vuex 中
      //                 store.commit('setStationUserInfo',res.data)
      //                 console.log('stationUserInfo', store.state.stationUserInfo)
      //             }
      //             }else{
      //             Notify({type:'warning',message:res.msg})
      //             }
      //         })
      //         }else if(this.userType == '2'){
      //         Login(dataArray).then(res =>{
      //             console.log(res);
      //             if(res.code == 0){
      //             const userToken = res.msg
      //             // 将用户token保存到vuex中
      //             // _this.changeLogin({Authorization:userToken})
      //             store.commit('changeLogin',{Authorization:userToken})
      //             // 登录成功，进入后台管理首页
      //             _this.$router.push({ path: '/manager' })
      //             // 把用户名、管理权限保存到 vuex 中
      //             const userInfo = {
      //                 userName:res.data.userName,
      //                 role:res.data.role
      //             }
      //             store.commit('setUserInfo', userInfo)
      //             console.log('userName', store.state.userName)
      //             console.log('userRole', store.state.role)
      //             }else{
      //             Notify({type:'warning',message:res.msg})
      //             }
      //         })
      //         }
      //     })
      //     .catch(error => {
      //         console.log('验证不通过');
      //         console.error('Validation failed:', error);
      //     });
      // },

      onSubmit(){
          // this.showModify = true
          // return
          let _this = this;
          console.log('表单数据：', _this.ruleForm);
          // debugger
          _this.$refs.ruleForm.validate()
          .then(valid => {
              // 表单验证成功
              // debugger
              console.log('验证通过');
              if(this.ruleForm.validCode != this.identifyCode){
              Notify({type:'warning',message:'图形验证码不一致'})
              return
              }
              const psd = md5(this.trimmedStr(this.ruleForm.password)).toUpperCase()
              console.log('加密后的密码',psd);
              this.md5Password = psd
              const dataArray = {
              userName:this.trimmedStr(this.ruleForm.userName),//用户名
              password:psd,//密码
              phoneNo: ''
              }
              console.log('dataArray',dataArray);
              if(this.userType == '1'){
                  if(this.rememberPassword){
                    // const savedUsers = JSON.parse(localStorage.getItem('users')) || []
                    // const userExists = savedUsers.some(user => user.username === this.ruleForm.userName && user.password === this.ruleForm.password)
                    // console.log('userExists',userExists);
                    StationUserLogin(dataArray).then(res =>{
                      console.log(res);
                      this.userInfo = res.data
                      if(res.code == 0){
                      const userToken = res.msg
                      // 将用户token保存到vuex中
                      store.commit('changeLogin',{Authorization:userToken})
      
                      const password = this.userInfo.idNo.substring(12,18)
                      const psd = md5(this.trimmedStr(password)).toUpperCase()
      
                      if(this.md5Password == psd){
                          console.log('密码是默认密码');
                          Dialog.alert({
                          title: '提示',
                          message: '<span style="color:#ff9933">该账号密码为初始化密码，为了保障账号的安全，请修改密码</span>',
                          confirmButtonColor: '#1989fa',
                          messageAlign:'left',
                          theme: 'round-button',
                          }).then(() => {
                          // on close
                          console.log('点击了确定');
                          // 修改密码提示框
                          this.showModify = true
                          
                          });
                      }else if(this.md5Password != psd){
                          console.log('密码不是默认密码');
                          // 登录成功，进入服务站管理首页
                          _this.$router.push({ path: '/stationIndex' })
                          // 把用户登录信息保存到 vuex 中
                          store.commit('setStationUserInfo',res.data)
                          console.log('stationUserInfo', store.state.stationUserInfo)
                          // const userExists = this.usernames.includes(this.ruleForm.userName);
                          const savedUsers = JSON.parse(localStorage.getItem('users')) || []
                          const userExists = savedUsers.some(user => user.username === this.ruleForm.userName && user.password === this.ruleForm.password)
                          console.log('是否保存过该用户',userExists);
                          if (!userExists) {
                            // 保存新用户
                            const newUser = {
                                username: this.ruleForm.userName,
                                password: this.ruleForm.password,
                                rememberPassword:this.rememberPassword,
                            };
                            const savedUsers = JSON.parse(localStorage.getItem('users')) || [];
                            savedUsers.push(newUser);
                            localStorage.setItem('users', JSON.stringify(savedUsers));
                          }
                      }
                      }else{
                      Notify({type:'warning',message:res.msg})
                      }
                  })
                  }else{
                      // 移除用户
                      const savedUsers = JSON.parse(localStorage.getItem('users')) || []
                      const undatedUsers = savedUsers.filter(user => user.username !== this.ruleForm.userName)
                      localStorage.setItem('users',JSON.stringify(undatedUsers))
                  } 
              }else if(this.userType == '2'){
               if(this.rememberPassword){
                Login(dataArray).then(res =>{
                    console.log(res);
                    if(res.code == 0){
                      const userToken = res.msg
                      // 将用户token保存到vuex中
                      // _this.changeLogin({Authorization:userToken})
                      store.commit('changeLogin',{Authorization:userToken})
                      // 登录成功，进入后台管理首页
                      _this.$router.push({ path: '/manager' })
                      // 把用户名、管理权限保存到 vuex 中
                      const userInfo = {
                          userName:res.data.userName,
                          role:res.data.role
                      }
                      store.commit('setUserInfo', userInfo)
                      console.log('userName', store.state.userName)
                      console.log('userRole', store.state.role)
                      const savedUsers = JSON.parse(localStorage.getItem('users')) || []
                      const userExists = savedUsers.some(user => user.username === this.ruleForm.userName && user.password === this.ruleForm.password)
                      console.log('是否保存过该用户',userExists);
                      // const userExists = this.usernames.includes(this.ruleForm.userName);
                      if (!userExists) {
                        // 保存新用户  450881199909218922
                        const newUser = {
                            username: this.ruleForm.userName,
                            password: this.ruleForm.password,
                            rememberPassword:this.rememberPassword,
                        };
                        const savedUsers = JSON.parse(localStorage.getItem('users')) || [];
                        savedUsers.push(newUser);
                        localStorage.setItem('users', JSON.stringify(savedUsers));
                      }
                    }else{
                      Notify({type:'warning',message:res.msg})
                    }
                })
               }else{
                  // 移除用户
                  const savedUsers = JSON.parse(localStorage.getItem('users')) || []
                  const undatedUsers = savedUsers.filter(user => user.username !== this.ruleForm.userName)
                  localStorage.setItem('users',JSON.stringify(undatedUsers))
               }
              }
          })
          .catch(error => {
              console.log('验证不通过');
              console.error('Validation failed:', error);
          });
      },
      // 返回首页
      goHome(){
          this.$router.push('/home')
          // this.$router.push('/stationIndex')
      },
      // 去除空格
      trimmedStr(str){
          return str.replace(/\s+/g,'')
      },
      // 图形验证码
      blurIdentifyNo(){
          this.identifyKeyboardShow = false//图形验证码
          //重置
          this.$nextTick(() => {
          const container = document.querySelector('.login');
          if (container) {
              container.style.paddingBottom = '0px';
              console.log('Container found and padding set');
              setTimeout(() => {
                  console.log('Scrolling to bottom');
                  container.scrollTop = container.scrollHeight;
                  console.log('Scroll top set to:', container.scrollTop);
              }, 100);
          } else {
              console.error('Container not found');
          }
          });
      },
      // 获取验证码
      // getMScode(){
      //       // this.phoneNoKeyboardShow= false
      //       let _this = this
      //         if(!_this.isValidPhone){
      //           Notify({ type: 'warning', message: '请输入正确的手机号！' });
      //           console.log('phoneVal:',_this.ruleForm.phoneNo);
      //           return
      //       }
      //       // 发送验证码
      //       console.log('发送验证码到手机号：',_this.ruleForm.phoneNo);
      //       // debugger
      //       const dataArray = {
      //               phoneNo:this.ruleForm.phoneNo,//手机号
      //               verifyCode:this.ruleForm.verifyNo,//验证码
      //               password: ''
      //             }
      //       LoginSms(dataArray,function(res){
      //         console.log('sendMessage',res);
      //         _this.code = res.msg
      //         console.log(_this.code);
      //       })
      //       // 倒计时
      //       _this.numShow = false
      //         let count = setInterval(()=>{
      //             _this.num--
      //             if(_this.num==0){
      //                 clearInterval(count)
      //                 _this.numShow=true
      //                 _this.num = 60
      //             }
      //         },1000)
      // },
      // 验证码点击刷新
      refreshCode(){
          this.identifyCode = ''
          this.makeCode(this.identifyCodes,4)
      },
      // 随机数
      randomNum(min,max){
          max = max + 1
          return Math.floor(Math.random() * (max - min) + min)
      },
      // 生成随机验证码
      makeCode(data,len){
          for(let i=0;i < len;i++){
          this.identifyCode += data[this.randomNum(0,data.length - 1)]
          }
          console.log('随机验证码：',this.identifyCode);
      },
      // 密码图标切换
      switchPasswordType(){
          this.passwordType = this.passwordType === 'password'?'text':'password'
      },
      // 修改密码图标切换
      changePasswordType(){
          this.modifyPasswordType = this.modifyPasswordType === 'password'?'text':'password'
      },
      // 修改密码
      submitOverlay(){
          console.log('点击了提交修改密码');
          // this.showModify = false
          this.$refs.modify.validate()
          .then(valid => {
              console.log('验证通过');
              if(this.modifyForm.modifyPassword != this.modifyForm.enterPassword){
              WarningMsgBox('两次密码不一致')
              }else{
                  console.log('modifyPassword',this.modifyForm.modifyPassword);
                  this.userInfo.password = md5(this.trimmedStr(this.modifyForm.modifyPassword)).toUpperCase()
                  console.log('userInfo',this.userInfo);
                  // return
                  ModifyStationUser(this.userInfo).then(res => {
                  console.log(res);
                  this.showModify = false
                  // Notify({message:'修改'+ res.msg,type:'success'})
                  // if(res.code == 0){
                  //   const savedUsers = JSON.parse(localStorage.getItem('users')) || []
                  //   const userExists = savedUsers.some(user => user.username === this.ruleForm.userName && user.password === this.ruleForm.password)
                  //   console.log('是否保存过该用户',userExists);
                  //   if (!userExists) {
                  //   // 保存新用户
                  //   const newUser = {
                  //       username: this.ruleForm.userName,
                  //       password: this.password,
                  //   };
                  //   const savedUsers = JSON.parse(localStorage.getItem('users')) || [];
                  //   savedUsers.push(newUser);
                  //   localStorage.setItem('users', JSON.stringify(savedUsers));
                  //   }
                  // }
                  Notify({message:'修改'+ res.msg,type:'success'})
                  })
                  // 清空登录表单
                  this.ruleForm.userName = ''
                  this.ruleForm.password = ''
                  this.ruleForm.validCode = ''
              }
          })
          .catch(error => {
              console.log('验证不通过');
              console.error('Validation failed:', error);})
      //  if(this.modifyForm.modifyPassword != this.modifyForm.enterPassword){
      //   WarningMsgBox('两次密码不一致')
      //  }else{
      //     console.log('modifyPassword',this.modifyPassword);
      //     this.userInfo.password = md5(this.trimmedStr(this.modifyPassword)).toUpperCase()
      //     console.log('userInfo',this.userInfo);
      //     // return
      //     ModifyStationUser(this.userInfo).then(res => {
      //       console.log(res);
      //       this.showModify = false
      //       Notify({message:'修改'+ res.msg,type:'success'})
      //     })
      //  }
      },
      // 用户选择
      onSelect(action) {
          this.ruleForm.userName = action.text
          this.onUserSelect(action.text)
      },
      onUserSelect(value) {
          // this.selectedUser = value;
          console.log('选择登录的用户:',value);
          console.log('usernames',this.usernames);
          
          const savedUsers = JSON.parse(localStorage.getItem('users')) || [];
          const selectedUserData = savedUsers.find(user => user.username === value);
          if (selectedUserData) {
            this.ruleForm.password = selectedUserData.password; // 自动填充密码
            this.rememberPassword = selectedUserData.rememberPassword; // 自动勾选记住密码
          }
          this.showPopover = false
      }
      
  }

}
</script>

<style lang="scss">
.login{
  width: 100%;
  // height: 100%;
  overflow-y: auto; /* 尝试使用 auto */
  // background-image: url('../../assets/loginbgc.png');
  // background-size: 100% 100%;
  background-image: url('../assets/loginbgc.png');
  background-size: cover; /* 背景图片覆盖整个容器 */
  background-repeat: no-repeat; /* 背景图片不重复 */
  background-clip: content-box; /* 背景裁剪到内容区域 */
.adminImg{
  margin: 4% auto 1%;
  width: 150px;
  height: 150px;
  border-radius: 50%;
  border: ghostwhite 1px solid;
  background-image: url('../assets/admin3.png');
  background-size: 100% 100%;
}
  .loginForm{
  width: 90%;
  height: 60%;
  margin: 0 auto;
  margin-top: 5%;
  // border: red 1px solid;
    .van-radio-group {
      display: flex;
      justify-content: space-between;
    }
}
.wrapper{
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
    }
    .title{
      margin-top: 3%;
      .cancel{
        float: right;
        margin-right: 3%;
        font-size: 28px;
      }
    }
    .statePoolBlock{
      width: 95%;
      // height: 50%;
      border-radius: 8px;
      background-color: #fff;
      .van-cell__value{
        text-align: left;
      }
    }
.van-password-input{
  margin: 0;
}
.van-number-keyboard{
    background-color: #F2F3F5;
    padding: 0;
  }
  .van-key{
    width: 100%;
  }
  .van-cell__value{
    text-align: left;
  }
  .van-button--small{
    padding: 0 10px;
  }
  .van-field__right-icon{
    color: #969799;
  }
  
}
.van-goods-action-button{
  font-size: 18px;
}
.van-dialog--round-button .van-dialog__footer{
  padding: 10px;
}
.van-popover__content{
  width: 170px;
}



</style>